<template>
  <div class="body" align="center">
    <div
      style="
        font-family: 'Roboto Serif', serif;
        font-weight: 500;
        font-size: 21px;
        line-height: 26px;
      "
    >
      Ready to start your practice?
    </div>
    <div
      style="
        padding-top: 18px;
        font-family: 'Roboto';
        font-weight: 300;
        font-size: 12px;
        line-height: 14px;
      "
    >
      Book a demo with an EHR Specialist today!
    </div>
    <div style="padding-top: 36px" align="left">
      <el-row class="roboto">First Name</el-row>
      <el-row>
        <el-input v-model="firstName"></el-input>
      </el-row>
      <el-row class="roboto">Last Name</el-row>
      <el-row>
        <el-input v-model="lastName"></el-input>
      </el-row>
      <el-row class="roboto">Email Address</el-row>
      <el-row>
        <el-input v-model="email"></el-input>
      </el-row>
      <el-row class="roboto">Contact Number</el-row>
      <el-row>
        <el-input v-model="number"></el-input>
      </el-row>
      <el-row class="roboto">How did you hear about us?</el-row>
      <el-row>
        <el-input v-model="source"></el-input>
      </el-row>
    </div>
    <div style="padding-top: 15px; padding-bottom: 43px">
      <el-button style="background-color: #ffffff; color: #3e6161" @click="request()">
        Request a Demo Now
        <i class="el-icon-right el-icon--right" style="font-size: 16px"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      number: undefined,
      source: undefined,
    };
  },
  methods: {
    request() {
      console.log(
        "inputs: ",
        this.firstName,
        this.lastName,
        this.email,
        this.number,
        this.source
      );
      if (
        !this.firstName ||
        !this.lastName ||
        !this.email ||
        !this.number ||
        !this.source
      ) {
        this.$message.error({
          message: "Please fill all blank inputs",
        });
        return;
      }
      this.$message.success({
        message: "Request sent successfully",
      });
    },
  },
};
</script>

<style scoped>
.body {
  background-color: #3e6161;
  color: #ffffff;
  padding: 36px 27px 0 27px;
}
.roboto {
  font-family: "Roboto";
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  padding-bottom: 6px;
}
.el-input {
  padding-bottom: 18px;
}
</style>
